import { ITransactionTypes } from '../interface/transactionTypes';
import { SystemConstants } from './constants';

export const TransactionTypes: Record<string, string> = {
  normal: 'Normal',
  important: 'Important',
  archived: 'Archived',
};
export enum TransactionTypesValue {
  billableMatter = 'billable-matter',
  internalMatter = 'internal-matter',
  matterTransactionTypes = 'matter-transaction-types',
  all = 'all',
}

export enum TransactionTypePriceKind {
  STANDARD = 'standard',
  UNIT = 'unit',
  HOUR = 'hour',
}

type PriceKindFields = Partial<Pick<ITransactionTypes, 'standardPrice' | 'unitId'>> & {
  unit?: Partial<ITransactionTypes['unit']>;
};

const isHourBasedTransactionType = ({ unitId, unit }: PriceKindFields): boolean => {
  const resolvedUnitId = unitId ?? unit?.id;
  return !resolvedUnitId || resolvedUnitId.toUpperCase() === SystemConstants.UNIT_HOUR;
};

// The model has no price-kind field, so a non-zero standard price wins over the unit.
export const getTransactionTypePriceKind = (type: PriceKindFields): TransactionTypePriceKind => {
  if (type.standardPrice != null && type.standardPrice !== 0) {
    return TransactionTypePriceKind.STANDARD;
  }
  return isHourBasedTransactionType(type)
    ? TransactionTypePriceKind.HOUR
    : TransactionTypePriceKind.UNIT;
};
